export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  brand: "nav-brand",
  about: "nav-about",
  services: "nav-services",
  fees: "nav-fees",
  calculator: "nav-calculator",
  blog: "nav-blog",
  contact: "nav-contact",
  langRo: "lang-toggle-ro",
  langEn: "lang-toggle-en",
  bookCta: "nav-book-cta",
};

export const HERO = {
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
};

export const CALC = {
  serviceSelect: "calc-service",
  complexitySelect: "calc-complexity",
  calculateBtn: "calc-calculate-btn",
  result: "calc-result",
  resultTotal: "calc-result-total",
};

export const CONTACT = {
  name: "contact-name",
  email: "contact-email",
  phone: "contact-phone",
  service: "contact-service",
  message: "contact-message",
  submit: "contact-submit",
  success: "contact-success",
  error: "contact-error",
};

export const BLOG = {
  list: "blog-list",
  card: (slug) => `blog-card-${slug}`,
  open: (slug) => `blog-open-${slug}`,
};
